export interface IVerifyAndConfirmAccount {
  code: string;
  email: string;
}

export interface IVerifyAndConfirmAccountPayload {
  code: string;
  email: string;
}

export interface IUserVerification {
  _id: string;
  userId: string;
  sessionId: string;
  clientSecret: string;
  type: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export const EmptyVerifyAndConfirmAccountPayload: IVerifyAndConfirmAccount = {
  code: "",
  email: "",
};
